/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';


// styles
import injectSheet from 'react-jss';
import styles from './configv3controller_styles';
import SplitButton from "../splitbutton/splitbutton";
import {Button} from "@insticator/insticator-ui";


/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - CONFIG CONTROLLER ~~~~~~~~~~ ========== */
const ConfigV3Controller = (props) => {
    const {
        icon,
        title,
        handleCancel,
        handleSave,
        handleToggle,
        handlePreview,
        handleDownload,
        isOpened,
        isChanged,
        isLoading,
        cancelTitle,
        saveTitle,
        isProcessing,
        disableSave,
        disabled,
        hideDefaultActionButtons, // when we hide save, cancel buttons and just allow user to toggle
        actionButtons
    } = props;

    const options = () => {
        if(!handleDownload) {
            return ['Preview'];
        } else {
            return ['Download Only', 'Preview'];
        }
    }
    return (
        <div className={`configv3controller ${props.classes.configv3controller} ${props.className} header controls opened-${isOpened} disabled-${disabled}`}
             onClick={() => {
                 handleToggle()
             }}>
            <div className={'header'}>
                {icon}
                <h2 className='title'>
                    {title}
                </h2>
            </div>

            <div className={'actions'}>
                {isOpened && !actionButtons  &&
                    <div className={`actionbuttons`} onClick={e => e.stopPropagation()}>
                        {handleCancel && <Button
                            variant={'system'}
                            text={cancelTitle || 'Cancel'}
                            type={'action'}
                            handleClick={handleCancel}
                            // disabled={isLoading}
                        />}
                        <SplitButton
                            handleCancel={handleCancel}
                            handleSave={handleSave}
                            handlePreview={handlePreview}
                            handleDownload={handleDownload}
                            isChanged={isChanged}
                            isLoading={isLoading}
                            cancelTitle={cancelTitle}
                            saveTitle={saveTitle}
                            isProcessing={isProcessing}
                            disableSave={disableSave}
                            options={options()}
                        ></SplitButton>
                    </div>
                }
            </div>
        </div>
    )
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ConfigV3Controller);
